/* Extracted from sections/faq-lights.liquid (inline script).
   One initializer per section instance; safe for multiple instances per page
   and re-runs on Shopify theme-editor section reloads. */

function initFaqLights(root) {
      if (!root || root.dataset.iraInit === '1') return;
      root.dataset.iraInit = '1';

      var mode = root.dataset.openMode || 'single';
      var configuredDuration = parseInt(root.dataset.duration || '0', 10);
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-ira-item]'));

      function getDuration() {
        return configuredDuration > 0 && !reduceMotion.matches ? configuredDuration : 0;
      }

      function getToken(el) {
        return parseInt(el.getAttribute('data-ira-token') || '0', 10);
      }

      function nextToken(el) {
        var token = getToken(el) + 1;
        el.setAttribute('data-ira-token', String(token));
        return token;
      }

      function animateOpen(item, body) {
        var duration = getDuration();
        var token = nextToken(body);

        if (!duration) {
          body.style.height = 'auto';
          return;
        }

        body.style.height = body.scrollHeight + 'px';

        function complete() {
          body.removeEventListener('transitionend', onEnd);
          clearTimeout(timer);

          if (getToken(body) === token && item.classList.contains('is-open')) {
            body.style.height = 'auto';
          }
        }

        function onEnd(event) {
          if (event.target === body && event.propertyName === 'height') {
            complete();
          }
        }

        var timer = setTimeout(complete, duration + 120);
        body.addEventListener('transitionend', onEnd);
      }

      function animateClose(body) {
        var duration = getDuration();
        var token = nextToken(body);

        if (!duration) {
          body.style.height = '0px';
          return;
        }

        var height = body.scrollHeight;
        body.style.height = height + 'px';
        void body.offsetHeight;

        requestAnimationFrame(function () {
          if (getToken(body) === token) {
            body.style.height = '0px';
          }
        });
      }

      function setOpen(item, open) {
        var trigger = item.querySelector('[data-ira-trigger]');
        var body = item.querySelector('.ira__body');
        var isOpen = item.classList.contains('is-open');

        if (open === isOpen) return;

        if (trigger) {
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        if (open) {
          item.classList.add('is-open');
          if (body) animateOpen(item, body);
        } else {
          if (body) animateClose(body);
          item.classList.remove('is-open');
        }
      }

      items.forEach(function (item) {
        var body = item.querySelector('.ira__body');
        if (!body) return;

        if (item.classList.contains('is-open')) {
          body.style.height = 'auto';
        } else {
          body.style.height = '0px';
        }
      });

      root.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-ira-trigger]');
        if (!trigger || !root.contains(trigger)) return;

        var item = trigger.closest('[data-ira-item]');
        if (!item) return;

        var willOpen = !item.classList.contains('is-open');

        if (mode === 'single') {
          items.forEach(function (other) {
            if (other !== item) setOpen(other, false);
          });
        }

        setOpen(item, willOpen);
      });

}

function initAllFaqLightss(scope) {
  (scope || document).querySelectorAll('[id^="IconRailAccordion-"]').forEach(initFaqLights);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { initAllFaqLightss(); });
} else {
  initAllFaqLightss();
}
document.addEventListener('shopify:section:load', function (event) {
  initAllFaqLightss(event.target);
});
